<template>
  <div>
    <PageAllow controller="SubAccountAnalyses" action="mfSubAccountView" />
    <Breadcrumbs :items="items" />

    <v-sheet class="overflow-y-scroll fill-content-height">
      <div class="mx-4 my-4">
        <v-data-table
          :headers="headers"
          :items="subAccountDetails"
          :options.sync="options"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:top>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <span class="font-weight-bold me-2">
                    {{ $t("SubAccountAnalyses.DetailInfo.accountNumber") }}
                  </span>
                  <span>{{ subAccount.third_account_number }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <span class="font-weight-bold me-2">
                    {{ $t("SubAccountAnalyses.DetailInfo.accountName") }}
                  </span>
                  <span>{{ subAccount.account_name }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <span class="font-weight-bold me-2">
                    {{ $t("SubAccountAnalyses.DetailInfo.subAccountType") }}
                  </span>
                  <span>
                    {{ subAccount.sub_account_type }}-
                    {{ subAccount.sub_account_type_name }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <span class="font-weight-bold me-2">
                    {{ $t("SubAccountAnalyses.DetailInfo.bank") }}
                  </span>
                  <span>
                    {{ subAccount.bank_code }}-
                    {{ subAccount.bank_name }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
          </template>

          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td colspan="3">
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ receive_account_price_total | formatMoney }}</span
                >
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ sub_account_price_total | formatMoney }}</span
                >
              </td>
              <td colspan="3"></td>
            </tr>
            <tr class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("TableSum") }}
                </div>
                <div class="v-data-table__mobile-row__cell"></div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("SubAccountAnalyses.DetailTableHeaders.receiveMoney") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }}
                  {{ receive_account_price_total | formatMoney }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{
                    $t("SubAccountAnalyses.DetailTableHeaders.subAccountMoney")
                  }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }}
                  {{ sub_account_price_total | formatMoney }}
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:item.sub_account_type="{ item }">
            {{ item.sub_account_type + "-" + item.sub_account_name }}
          </template>
          <template v-slot:item.branchname="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.branchname }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.branchcode }}
            </span>
          </template>
          <template v-slot:item.pay_detail.ordercode="{ item }">
            {{ item.pay_detail.ordercode }}
          </template>
          <template v-slot:item.receive_sub_account_money="{ item }">
            {{ $t("Global.money") }}
            {{ item.receive_sub_account_money | formatMoney }}
          </template>
          <template v-slot:item.sub_account_money="{ item }">
            {{ $t("Global.money") }}
            {{
              (item.sub_account_time ? item.sub_account_money : 0) | formatMoney
            }}
          </template>
          <template v-slot:item.pay_detail.paytime="{ item }">
            {{ item.pay_detail.paytime | formatTime }}
          </template>
          <template v-slot:item.sub_account_time="{ item }">
            {{ item.sub_account_time | formatTime }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import consts from "@/consts";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Authorizations from "@/api/authorizations";
import ShopSubAccount from "@/api/shop_sub_account";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopSubAccountSum", [consts.shopName()]),
          disabled: false,
          href: "/shop-sub-account-sum",
        },
        {
          text: i18n.t("Nav.shopSubAccountSumDetail", [consts.shopName()]),
          disabled: true,
          href: "/shop-sub-account-sum/detail",
        },
      ];

      return items;
    },

    headers() {
      return [
        {
          text: i18n.t("ShopSubAccountSum.DetailFields.voucher_code"),
          align: "start",
          sortable: false,
          value: "pay_detail.tradeno",
        },
        {
          text: i18n.t("ShopSubAccountSum.DetailFields.shop"),
          align: "start",
          sortable: false,
          value: "order.branchname",
        },
        {
          text: i18n.t("ShopSubAccountSum.DetailFields.order"),
          align: "start",
          sortable: false,
          value: "pay_detail.orderno",
        },
        {
          text: i18n.t("ShopSubAccountSum.DetailFields.receive_money"),
          align: "end",
          sortable: false,
          value: "receive_sub_account_money",
        },
        {
          text: i18n.t("ShopSubAccountSum.DetailFields.subAccount_money"),
          align: "end",
          sortable: false,
          value: "sub_account_money",
        },
        {
          text: i18n.t("ShopSubAccountSum.DetailFields.receive_time"),
          align: "start",
          sortable: false,
          value: "pay_detail.paytime",
        },
        {
          text: i18n.t("ShopSubAccountSum.DetailFields.sub_account_time"),
          align: "start",
          sortable: false,
          value: "sub_account_time",
        },
      ];
    },

    ...mapState(["loading", "settings", "accessToken"]),
  },

  data: () => ({
    paging: {},
    options: {},
    subAccountDetails: [],
    subAccount: {},
    receive_account_price_total: 0,
    sub_account_price_total: 0,
    indexOptions: {},
  }),

  mounted() {
    //取一览页session中的搜索条件
    this.$commonUtils.loadOptions("shop-sub-account").then(
      function (data) {
        if (data.options) {
          this.indexOptions = data.options;
        }
      }.bind(this)
    );
    this.getOrders();
  },

  methods: {
    checkAccessToken() {
      Authorizations.checkAccessTokenToMid({
        yywd_access_token: this.accessToken,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            localStorage.setItem("midAccessToken", response.data.access_token);
            this.getOrders();
          }
        }.bind(this)
      );
    },
    getOrders() {
      if (
        localStorage.getItem("third_account_number") &&
        localStorage.getItem("sub_account_type")
      ) {
        // if (this.$route.query.sub_account_type == "TK") {
        //   ShopSubAccount.fetchReturnOrders({
        //     third_account_number: this.$route.query.third_account_number,
        //   }).then(
        //     function (response) {
        //       if (response.data.status.isOK()) {
        //         this.subAccount = response.data.subAccount;
        //         this.subAccountDetails = response.data.orders;
        //       }
        //     }.bind(this)
        //   );
        // } else {
        var options = {
          third_account_number: localStorage.getItem("third_account_number"),
          sub_account_type: localStorage.getItem("sub_account_type"),
          limit: consts.limitAll,
        };
        if (this.indexOptions.datetimeRadioSelected == "sub_account") {
          options = Object.assign({}, options, {
            sub_account_time_from: this.indexOptions.sub_account_time_from,
            sub_account_time_to: this.indexOptions.sub_account_time_to,
          });
        } else if (this.indexOptions.datetimeRadioSelected == "created") {
          options = Object.assign({}, options, {
            created_time_from: this.indexOptions.created_time_from,
            created_time_to: this.indexOptions.created_time_to,
          });
        }

        ShopSubAccount.fetchOrders(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.subAccount = response.data.subAccount;
              this.subAccountDetails = response.data.sub_account_details;
              this.receive_account_price_total =
                response.data.receive_account_price_total;
              this.sub_account_price_total =
                response.data.sub_account_price_total;
            } else if (response.data.error.code == "ERR667") {
              this.checkAccessToken();
            }
          }.bind(this)
        );
        // }
      }
    },
  },

  watch: {
    indexOptions: {
      deep: true,
      handler() {
        if (Object.keys(this.indexOptions).length) {
          this.getOrders();
        }
      },
    },
  },
};
</script>